import CommunityDetail from '@/modules/community-hub/components/community-detail';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/communities/$slug')({
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();
  return <CommunityDetail slug={slug} />;
}
